export default __webpack_public_path__ + "static/media/review.a6450ecd.svg";